import { useNavigate } from "react-router-dom";
import { Button } from "../../../../../components/buttons/button";
import { ContainerCard } from "../../../../../components/cards/containerCard";
import { InformationCardNoIcon } from "../../../../../components/cards/infoCard";
import { TextInputViewOnly } from "../../../../../components/inputs/textInputViewOnly";
import { UploadedFileView } from "../../../../../components/inputs/uploadedFileView";
import { ProfilePicture } from "../../../../../components/profile/profilePicture";
import {
  decodeUrl,
  formatDate,
  getTextFromStatus,
} from "../../../../../helperFunctions";
import { useAppSelector } from "../../../../../redux/hooks";

export const CooperativeProfileView = () => {
  const { profile } = useAppSelector((state) => state.auth);

  const navigate = useNavigate();

  const goToProfileEdit = () => {
    navigate("/app/settings/profile/edit");
  };

  return (
    <div className="w-full flex flex-row flex-wrap gap-2 md:gap-6">
      {/* Main information half */}
      <div className="w-full md:max-w-[500px] order-last md:order-first">
        <InformationCardNoIcon
          className="mb-2 md:mb-4"
          info={
            <p>
              Click the{" "}
              <span className="text-pry-green-200 font-medium">Edit</span>{" "}
              button to provide required information and documents
            </p>
          }
        />

        <ContainerCard className="flex flex-col gap-7">
          {/* Title and button */}
          <div className="w-full flex flex-row gap-4 items-center justify-between">
            <h1 className="font-bold text-base">Cooperative Profile</h1>

            <Button
              text="Edit"
              onClick={() => {
                goToProfileEdit();
              }}
              type="button"
              className="!min-w-[82px] md:!min-w-[107px] !w-fit"
              size="medium"
              loading={false}
              disabled={false}
              variation="primary"
            />
          </div>

          {/* Profile details */}
          <div className="flex flex-col gap-2">
            <TextInputViewOnly
              className=""
              text="Cooperative Description"
              subtext={
                profile?.description
                  ? ""
                  : "Tell us something about your cooperative"
              }
              hasIcon={!profile?.description}
              extraContent={
                profile?.description && <div>{profile?.description}</div>
              }
            />

            <TextInputViewOnly
              className=""
              text="Certificate of Registration"
              subtext={
                profile?.Certificate
                  ? ""
                  : "Upload your cooperative certificate of registration"
              }
              hasIcon={!profile?.Certificate}
              extraContent={
                profile?.Certificate && (
                  <UploadedFileView
                    viewLink={`${decodeUrl(profile?.Certificate)}`}
                    text={getTextFromStatus(profile?.Certificatestatus)}
                    variant="mini"
                    status={profile?.Certificatestatus}
                  />
                )
              }
            />

            <TextInputViewOnly
              className=""
              text="Bye Laws or Constitution"
              subtext={
                profile?.byelaw
                  ? ""
                  : "Upload cooperative bye laws or constitution"
              }
              hasIcon={!profile?.byelaw}
              extraContent={
                profile?.byelaw && (
                  <UploadedFileView
                    viewLink={`${decodeUrl(profile?.byelaw)}`}
                    text="View document"
                    variant="mini"
                  />
                )
              }
            />

            <TextInputViewOnly
              className=""
              text="Email Address"
              subtext={profile?.CoopEmail}
              hasIcon={false}
            />

            <TextInputViewOnly
              className=""
              text="Date Created"
              subtext={formatDate(profile?.DateAdded)}
              hasIcon={false}
            />
          </div>
        </ContainerCard>
      </div>

      {/* Logo half */}
      <ContainerCard
        className="
        flex flex-col items-center justify-center
        gap-6 md:sticky-top flex-1 !h-fit
        "
      >
        <div className="w-full max-w-[353px] text-center">
          <p className="font-bold text-base">Cooperative Logo</p>

          <p className="mt-1 text-pry-dark-green-300/60">
            Your logo will be visible to your members on ThriftCorp
          </p>
        </div>

        <ProfilePicture className="!w-[106px] !h-[106px] !text-2xl !font-bold" />

        <Button
          text={profile?.logo ? "Change logo" : "Add a logo"}
          onClick={goToProfileEdit}
          type="button"
          className="!min-w-[80px] !max-w-fit"
          size="small"
          loading={false}
          disabled={false}
          variation="secondary-light"
        />
      </ContainerCard>
    </div>
  );
};
